import { Injectable } from '@angular/core';
import { SignupFlowService } from '@app/modules/signup-new/services/signup-flow.service';

const stepsB: SignupStepperStep[] = [
  { label: 'Welcome', completed: true },
  { label: 'Details' },
  { label: 'Properties' },
  { label: 'Completion' },
];

const stepsC: SignupStepperStep[] = [
  { label: 'Welcome', completed: true },
  { label: 'Properties' },
  { label: 'Details' },
  { label: 'Completion' },
];

interface SignupStepperStep {
  label: 'Welcome' | 'Details' | 'Properties' | 'Completion';
  completed?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class SignupStepperService {
  currentStep = 0;
  steps: SignupStepperStep[] = stepsB;

  constructor(private signupFlowService: SignupFlowService) {
    this.signupFlowService.flow$.subscribe((value) => {
      switch (value) {
        case 'B':
          this.steps = [...stepsB];
          break;
        case 'C':
          this.steps = [...stepsC];
          break;
      }
    });
  }

  complete(stepLabel: SignupStepperStep['label']) {
    const stepIndex = this.steps.findIndex((step) => step.label === stepLabel);
    this.currentStep = stepIndex;

    if (stepIndex === -1) return;

    this.steps.forEach((step, index) => (step.completed = index <= stepIndex));
  }

  reset() {
    this.currentStep = 0;
    this.steps.forEach((step, index) => (step.completed = index === 0));
  }
}
